/**
 * Returns boolean representing current browser touch mode.
 * @returns {boolean} - true when browser is in touch-enabled mode.
 */
function check_touch_enabled() {
  return !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches;
}

// Swatch king swatches
// obsere changes in Swatch king
// selecting first swatch can reload second(others) swatch HTML so  disconnecting observer is not an option
var has_observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (added_node) {
      if (added_node.className && added_node.className.startsWith("swatch-single")) {
        var options_count = 0;
        //$('.product-form__add-button').attr('disabled', false);
        $(".swatch-single").each(function () {
          options_count++;
          var that = $(this),
            option_name = that.find(".swatch-option-name");
          // that.find('.swatch-label').data('num',options_count)
          if (that.has(".option_number").length <= 0) {
            that.attr("data-num", options_count);
            if (option_name.length) {
              option_name.prepend(`<div class="option_number">${options_count}</div>`);
              option_name.prepend(`<span class="selected_tick hidden" data-num="${options_count}"></span>`);
            } else {
              option_name = that.find(".swatch-label");
              option_name.prepend(`<div class="option_number">${options_count}</div>`);
              option_name.prepend(`<span class="selected_tick hidden" data-num="${options_count}"></span>`);
            }
          }
        });
        // has_observer.disconnect();
      }
    });
  });
});

if( typeof window.hulkapps !== 'undefined' ) {
  var els_to_observe = document.getElementById("product_form_" + window.hulkapps.product_id);
  if (els_to_observe) {
    has_observer.observe(els_to_observe, { attributes: false, childList: true, subtree: true });
  }
}

/**
 * Hulkapps product infinite options
 */
// detect when options are injected into DOM
var ha_observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (added_node) {
      // fire up only when options are added to div
      if (added_node.id == "hulkapps_options_" + window.hulkapps.product_id) {
        // Default theme selectors
        // var options_count = $('.option_number').length;
        // Swatches king app selectors
        var options_count = $(".product-form .swatch-single").length;
        // disable add to cart btn
        // $('.product-form__add-button').attr('disabled', 'disabled');
        $(".hulkapps_option").each(function () {
          options_count++;
          $(this).find(".hulkapps_option_name").prepend(`<div class="option_number">${options_count}</div>`);
          $(this).find(".hulkapps_option_name").prepend(`<span class="selected_tick hidden"></span>`);
        });
        // ha_observer.disconnect();
      }
    });
  });
});
var el_to_observe = document.getElementById("hulkapps_custom_options_" + window.hulkapps.product_id);
if (el_to_observe) {
  ha_observer.observe(el_to_observe, {
    childList: true,
  });
}

// temp fix Switch king and hulkapp
$(document).ready(function ($) {
  // Switch king hides this one, but it needs to be displayed because of Hulkapp otipons
  $(".product-form__variants").attr("style", "display: block !important");
  // hide all other selectors. Selectors from Switch king app configuration
  $('.product-form__option, form[action="/cart/add"] .product__variants, form[action="/cart/add"] .form__row div.selector-wrapper, form .swatch.clearfix').attr("style", "display: none !important");
});

// works only when add to cart redirects to cart page
// not working with ajax/drawer/message add to cart
$(document).on("submit", ".product-form", function (e) {
  var isValid = true;
  $(".product-form .hulkapps_option").each(function () {
    if ($(this).hasClass("is_selected") == false) {
      $(this).addClass("validation_error");
      isValid = false;
    }
  });
  $(".product-form .swatch-single").each(function () {
    if ($(this).hasClass("is_selected") == false) {
      $(this).addClass("validation_error");
      isValid = false;
    }
  });

  if (!isValid) {
    e.preventDefault();
  }
});

//
/**
 * ITG JS:
 * ======
 */
$(document).ready(function () {
  $(document)
    .find("#itg-new-search")
    .find(".search-bar__submit")
    .on("click", function (event) {
      event.preventDefault();
      var searchValue = $(document).find("#itg-new-search").find(".itg-new-search-input-field").val();
      if (searchValue == "") {
        $(document).find(".itg-search-reset").click();
      } else {
        var collection = $(document).find("#itg-new-search").find(".itg-new-search-input-field").data("collection");
          var searchUrl = "/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=show&q=" + searchValue;
         // var searchUrl = "/collections/"+collection+"/Brand_&q=Brand_" + searchValue;
        //console.log('Loading..');
        $(document).find(".collection-wrapper").addClass("loading");
        $.ajax({
          url: searchUrl,
          type: "GET",
          dataType: "html",
          success: function (data) {
            var count = $(data).find(".itg-data-count").data("count");
            var html = "";
            var findSearch = 0;
            var findCount = 0;
            $(data)
              .find(".product-item")
              .each(function () {
                var collections = $(this).data("collections");
                var collectionArray = collections.split(",");
                var find = 0;
                $.each(collectionArray, function (index, value) {
                  if (value === collection) {
                    find = 1;
                  }
                });
                //console.log(find);
                if (find === 1) {
                  html += '<div class="product-item product-item--vertical  1/3--tablet-and-up 1/4--desk">';
                  html += $(this).html();
                  html += "</div>";
                  findSearch = 1;
                  findCount = findCount + 1;
                }
              });
            //console.log(findSearch);
            //console.log(html);
            $(document).find(".itg-search-query").text(searchValue);
            $(document)
              .find(".itg-search-showing-count")
              .text("Showing " + findCount + " - " + findCount + " of " + findCount + " product");
            if (findSearch == 1) {
              $(document).find(".itg-show-collection").find(".product-list").html(html);
            } else {
              $(document).find(".itg-show-collection").find(".product-list").html("No result Found");
            }
            $(document).find(".itg-show-collection").show();
            $(document).find(".itg-hide-collection").hide();
            $(document).find(".collection-wrapper").removeClass("loading");
            $(document).find(".itg-search-reset").removeClass("disabled");
            // }
          },
          error: function (xhr, status) {
            location.reload();
          },
        });
      }
    });
  $(document)
    .find("#itg-new-search")
    .find(".itg-new-search-input-field")
    .on("keydown", function (event) {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode === 13) {
        event.preventDefault();
        var searchValue = $(this).val();
        if (searchValue == "") {
          $(document).find(".itg-search-reset").click();
        } else {
         // var collection = $("this").data("collection");
          var collection = $("input.itg-new-search-input-field.is-filled").attr("data-collection");

          //var searchUrl = "/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=show&q=" + searchValue;
          var searchUrl = "/collections/"+collection+"/Brand_" + searchValue;
          //console.log('Loading..');
          $(document).find(".collection-wrapper").addClass("loading");
          $.ajax({
            url: searchUrl,
            type: "GET",
            dataType: "html",
            success: function (data) {
              var count = $(data).find(".itg-data-count").data("count");
              var html = "";
              var findSearch = 0;
              var findCount = 0;
              $(data)
                .find(".product-item")
                .each(function () {
                  var collections = $("input.itg-new-search-input-field.is-filled").attr("data-collection");
                  var collectionArray = collections.split(",");
                  var find = 0;
                  $.each(collectionArray, function (index, value) {
                    if (value === collection) {
                      find = 1;
                    }
                  });
                  //console.log(find);
                  if (find === 1) {
                    html += '<div class="product-item product-item--vertical  1/3--tablet-and-up 1/4--desk">';
                    html += $(this).html();
                    html += "</div>";
                    findSearch = 1;
                    findCount = findCount + 1;
                  }
                });
              //console.log(findSearch);
              //console.log(html);
              $(document).find(".itg-search-query").text(searchValue);
              $(document)
                .find(".itg-search-showing-count")
                .text("Showing " + findCount + " - " + findCount + " of " + findCount + " product");
              if (findSearch == 1) {
                $(document).find(".itg-show-collection").find(".product-list").html(html);
              } else {
                $(document).find(".itg-show-collection").find(".product-list").html('<div class="not-found">No result Found</div>');
              }
              $(document).find(".itg-show-collection").show();
              $(document).find(".itg-hide-collection").hide();
              $(document).find(".collection-wrapper").removeClass("loading");
              $(document).find(".itg-search-reset").removeClass("disabled");
              // }
            },
            error: function (xhr, status) {
              location.reload();
            },
          });
        }
      }
    });
  $(document)
    .find(".itg-search-reset")
    .on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("disabled")) {
      } else {
        $(document).find(".itg-new-search-input-field").val("");
        $(document).find(".itg-hide-collection").show();
        $(document).find(".itg-show-collection").hide();
        $(this).addClass("disabled");
      }
    });
});

$(document).ready(function () {
  $(document).on("change", "#faster-checkbox", function () {
    if ($(this).is(":checked")) {
      $(document).find(".shopify-payment-button__button").attr("disabled", true);
    } else {
      $(document).find(".shopify-payment-button__button").attr("disabled", false);
    }
  });
});

// @Colored Byte - CustomJs

// Handling collection filter navigation properly
(() => {
  const _mainCategoryHandle = document.querySelector('select.maincategory')?.selectedOptions[0].dataset.handle;
  const _subCategories = document.querySelectorAll('select.subcategory');
  _subCategories.forEach(subcategory => {
    const subCategoryValue = subcategory.dataset.value;
    if (_mainCategoryHandle == subCategoryValue) {
      subcategory.classList.remove('itg-hide');
    } else {
      subcategory.classList.add('itg-hide');
    }
  })
})();

// Code to show up/hide announcement newsletter
(() => {
  const headerNewsletterToggle = document.getElementById('header-newsletter-toggle')
  const newsletterClose = document.querySelector('.announcement-bar__close');
  headerNewsletterToggle.addEventListener('click', (e) => {
    const announcementBarNewsletter = document.getElementById('announcement-bar-newsletter');
    const announcementIsClosed = announcementBarNewsletter.ariaHidden == 'true';

    if (announcementIsClosed) {
      announcementBarNewsletter.style.height = 'auto'
      announcementBarNewsletter.ariaHidden = false;
    }
  })

  if(newsletterClose !== null) {
    newsletterClose.addEventListener('click', (e) => {
      const announcementBarNewsletter = document.getElementById('announcement-bar-newsletter');

      announcementBarNewsletter.style.height = 0;
      announcementBarNewsletter.ariaHidden = true;
    })
  }
})();

// Search-bar results JS
(() => {
  window.addEventListener('theme:search:done', (e) => {

    const qtyButtons = document.querySelectorAll('.search-results__qty-button')
    qtyButtons.forEach(button => {
      button.addEventListener('click', () => {
        const quantityElement = button.parentNode.querySelector('.search-results__qty-amount');
        const buttonAdds = button.classList.contains('qty-plus');

        if (buttonAdds) {
          quantityElement.value = parseInt(quantityElement.value) + 1
        } else {
          if (parseInt(quantityElement.value) > 1) {
            quantityElement.value = parseInt(quantityElement.value) - 1
          }
        }
      })
    })
  })
})();


// Code to shows up the Stars Reviews
(() => {
  window.addEventListener('load', () => {
    const reviewBlock = document.querySelectorAll('.CB-featuredProducts .starReview')
    const arrayReviews = Array.from(reviewBlock);

    if (arrayReviews != null & reviewBlock != null) {
      arrayReviews.forEach(review => {
        const reviewQuantity = review.querySelectorAll('.yotpo-sr-bottom-line-text')[0]?.innerHTML
        const reviewNumber = reviewQuantity?.replace(/\D/g, '');

        reviewNumber !== '0' ? review.classList.replace("hideStarReview", "showStarReview") : ''
      });
    }
  })
})();